import { Pipe, PipeTransform} from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'localeDatetimeFormat',
  standalone: true,
})
export class LocaleDatetimeFormatPipe implements PipeTransform {

  public transform(value: string): string {
    return value ? dayjs(value).format('L LT') : null;
  }
}
